import axios from 'axios'

export const reEnableCandidateAttempt = async (payload) => {
  const response = await axios.put(`candidate-attempts/re-enable`, payload)
  return response
}

/**
 *
 * @param {string} workspaceId
 * @param {boolean} assessment
 * @returns List of all  Contest for a particular workspace
 */
export const getAllContest = async (assessment, workspaceId) => {
  const response = await axios.get(
    `contests?workspaceId=${workspaceId}${`&isAssessment=${assessment?.toString()}`}`
  )
  return response
}

export const getAllContestList = async (payload) => {
  const response = await axios.post(`contests/list`, payload)
  return response
}

/**
 *
 * @param {string} contestId
 * @returns
 */
export const getContestById = async (contestId, assessment) => {
  const response = await axios.get(
    `contests/${contestId}?isAssessment=${assessment}`,
    { checkWorkspaceId: true }
  )
  return response
}

/**
 *
 * @param {object} payload  create contest payload
 * @returns
 */
export const createContest = async (payload) => {
  const response = await axios.post('contests', payload)
  return response
}

/**
 * @param {string} contestId
 * @param {object} payload  update contest payload
 * @returns
 */
export const updateContest = async (contestId, payload) => {
  const response = await axios.put(`contests/${contestId}`, payload)
  return response
}

/**
 * @param {string} contestId
 * @returns
 */
export const cloneContest = async (contestId) => {
  const response = await axios.get(`contests/clone`, {
    params: {
      contestId
    }
  })
  return response
}

/**
 *
 * @returns list of skills for a contest
 */
export const getTechnologies = async (workspaceId) => {
  const response = await axios.get(`job-descriptions/technologies`, {
    params: { workspaceId }
  })
  return response
}

/**
 *
 * @param {string} workspaceId
 * @returns list of job roles from evaluation templates
 */
export const getJobTitles = async (workspaceId) => {
  const response = await axios.get(`templates/job-titles`, {
    params: { workspaceId }
  })
  return response
}

/**
 *
 * @param {object} payload
 * @returns generate stages template based on job description
 */
export const fetchTemplateByJobDescription = async (payload) => {
  const response = await axios.post(`contest-stages/generate`, payload)
  return response
}

/**
 *
 * @param {string} contestId
 * @returns list of stage for a contest
 */
export const getAllStageForContest = async (contestId) => {
  const response = await axios.get(`contest-stages?contestId=${contestId}`)
  return response
}

/**
 *
 * @param {string} stageId
 * @returns stage for the id
 */
export const getStageById = async (stageId) => {
  const response = await axios.get(`contest-stages/${stageId}`, {
    checkWorkspaceId: true
  })
  return response
}

/**
 *
 * @param {object} payload  create contest stage payload
 * @returns
 */
export const createContestStage = async (payload) => {
  const response = await axios.post('contest-stages', payload)
  return response
}

/**
 * @param {string} stageId
 * @param {object} payload  update contest stage payload
 * @returns
 */
export const updateContestStage = async (stageId, payload) => {
  const response = await axios.put(`contest-stages/${stageId}`, payload)
  return response
}

/**
 *
 * @param {string} contestUri
 * @param {string} workspaceId
 * @returns
 */
export const getAllCandidateByContestURI = async (
  contestUri,
  payload,
  { isRegistered = false, hasResumeStage = false },
  signal
) => {
  const response = await axios.post(
    `contests/${contestUri}/candidates-list`,
    payload,
    {
      params: {
        isRegistered,
        hasResumeStage
      },
      signal
    }
  )
  return response
}

/**
 *
 * @param {string} stageId
 * @returns
 */
export const getAllCandidatesForStageEnable = async (stageId) => {
  const response = await axios.get(
    `candidate-attempts?contestStageId=${stageId}`
  )
  return response
}

export const enableStageForSelectedCandidate = async (candidates) => {
  const response = await axios.post('candidate-attempts', candidates)
  return response
}

/**
 *
 * @param {object} payload
 * @returns list of candidate appeared in the stage
 */
export const getLeaderBoardDetails = async (payload, signal) => {
  const response = await axios.post(`contest-stages/dashboard`, payload, {
    signal
  })
  return response
}

export const getAssessmentStageLeaderBoard = async (
  contestStageId,
  signal = null
) => {
  const response = await axios.get(`attempt-results/all-attempts`, {
    params: {
      contestStageId
    },
    signal
  })
  return response
}

export const exportContestDashboardCsvFile = async (payload) => {
  const response = await axios.post(
    `contest-stages/dashboard-export`,
    payload,
    { responseType: 'blob' }
  )
  return response
}

/**
 *
 * @param {number} attemptId
 * @param {boolean} attemptLogs
 * @returns the attempt detail array for all the challenges
 *
 */
export const getAttemptDetails = async (attemptId, attemptLogs) => {
  const response = await axios.get(
    `attempt-results/stats?attemptId=${attemptId}${
      attemptLogs ? `&attemptLogs=true` : ''
    }`
  )
  return response
}

/**
 *
 * @param {string} attemptId
 * @param {string} programmingChallengeId
 * @returns
 */
export const getAttempEvaluations = async (
  attemptId,
  programmingChallengeId
) => {
  const response = await axios.get(
    `attempt-logs?attemptId=${attemptId}${
      programmingChallengeId
        ? `&programmingChallengeId=${programmingChallengeId}`
        : ''
    }`
  )
  return response
}

export const uploadInviteCandidateCSV = async (filePayload, contestId) => {
  const response = await axios.post(
    `candidates/batch-invite?contestId=${contestId}`,
    filePayload
  )
  return response
}

/**
 *
 * @param {string} attemptId
 * @returns
 */
export const getSuspiciousActivity = async (
  attemptId,
  programmingChallengeId = null
) => {
  const response = await axios.get(
    `attempt-results/suspicious-activity?attemptId=${attemptId}${
      programmingChallengeId
        ? `&programmingChallengeId=${programmingChallengeId}`
        : ''
    }`
  )
  return response
}

/**
 *
 * @param {string} attemptId
 * @returns
 */
export const getMCQEvaluations = async (attemptId) => {
  const response = await axios.get(`attempt-results/mcq?attemptId=${attemptId}`)
  return response
}

/**
 *
 * @param {Object} payload
 * @returns
 */
export const enableMoveToNextStage = async (payload) => {
  const response = await axios.post(
    `candidate-attempts/enable-next-stage`,
    payload
  )
  return response
}

/**
 *
 * @param {Object} payload
 * @returns
 */
export const rejectLeaderboardAttempts = async (payload) => {
  const response = await axios.post(`candidate-attempts/reject/v2`, payload)
  return response
}

/**
 *
 * @param {string} contestUri
 * @returns
 */
export const validateContestUri = async (contestUri) => {
  const response = await axios.get(`contests/validate-uri?uri=${contestUri}`)
  return response
}

/**
 *
 * @param {object} payload
 * @returns
 */
export const checkCodeFiles = async (payload) => {
  const response = await axios.post(`challenge/check-code-files`, payload)
  return response
}

/**
 *
 * @param {string} attemptId
 * @returns
 */
export const attemptLogs = async (attemptId) => {
  const response = await axios.get(`attempt-logs/events?attemptId=${attemptId}`)
  return response
}

/**
 *
 * @param {string} attemptId
 * @returns
 */
export const attemptsVideos = async (attemptId) => {
  const response = await axios.get(
    `candidate-attempts/videos?attemptId=${attemptId}`
  )
  return response
}

export const newAttemptsVideos = async (attemptId) => {
  const response = await axios.get(
    `candidate-attempts/processed-videos?attemptId=${attemptId}`
  )
  return response
}

export const getAttemptMediaSharingDetails = async (candidateId, stageId) => {
  const response = await axios.get(
    `candidate-attempts/media-sharing-info?candidateId=${candidateId}&stageId=${stageId}`
  )
  return response
}

/**
 *
 * @param {Object} payload
 * @returns
 */
export const updateAttemptMediaSharing = async (payload) => {
  const response = await axios.put(
    `candidate-attempts/update-media-flags`,
    payload
  )
  return response
}

/**
 *
 * @param {Object} payload
 * @returns
 */
export const fetchContestLeaderboard = async (payload) => {
  const response = await axios.post(`leaderboard`, payload)
  return response
}

/**
 *
 * @param {string} stageId {number} estimatedCandidates
 * @returns quota for particular stage's challenge
 */
export const getFeatureQuota = async (stageId, estimatedCandidates = 0) => {
  const response = await axios.get(
    `credits/usage?contestStageId=${stageId}&candidates=${estimatedCandidates}`
  )
  return response
}

export const getEstimatedUsageForContest = async (
  contestStageId,
  previousStageId
) => {
  const response = await axios.get(`/credits/estimate-usage`, {
    params: { contestStageId, previousStageId }
  })

  return response
}

/**
 *
 * @param {object} payload
 * @returns total candidates for any stage
 */
export const getTotalCandidates = async (payload) => {
  const response = await axios.post(`candidate-schedules/candidates`, payload)
  return response
}

/**
 *
 * @param {Number} contestId
 * @param {Number} candidateId
 * @param {Number} userId
 * @returns
 */
export const fetchUserDetails = async (contestId, candidateId, userId) => {
  const response = await axios.get(
    `candidates/details?contestId=${contestId}${
      candidateId ? `&candidateId=${candidateId}` : ''
    }${userId ? `&userId=${userId}` : ''}`
  )
  return response
}

/**
 *
 * @param {string} attemptId
 * @returns
 */
export const reEnableStageForAttempt = async (attemptId) => {
  const response = await axios.put(
    `candidate-attempts/re-enable?attemptId=${attemptId}`
  )
  return response
}

/**
 *
 * @param {number} candidateId
 * @param {number} contestId
 * @returns
 */
export const resendCandidateInvite = async (candidateId, contestId) => {
  const response = await axios.post(`candidates/resend-invite`, {
    contestId,
    candidateId
  })
  return response
}

/**
 *
 * @param {object} details
 * @returns
 */
export const updateDemoChallengePrerequisite = async (details) => {
  const response = await axios.post(`candidates/prerequisite`, details)
  return response
}

/**
 *
 * @param {object} details {contestId,candidateId}
 * @returns
 */
export const skipPrerequisiteCheck = async (details) => {
  const response = await axios.put(`candidates/skip-prerequisite`, details)
  return response
}

/**
 *
 * @param {Number} contestStageId
 * @param {Number} candidateId
 * @returns
 */
export const concludeInterview = async (contestStageId, candidateId) => {
  const response = await axios.post('contest-stages/conclude-interviews', {
    contestStageId,
    candidateId
  })
  return response
}

/**
 *
 * @param {string} contestId
 * @returns boolean value
 */
export const getInvitePermission = async (contestId = null, signal = null) => {
  const response = await axios.get(
    `candidates/allow-invite?contestId=${contestId}`,
    {
      signal
    }
  )
  return response
}

//Contest Dashboard Realted APIs
/**
 *
 * @param {string} contestId
 * @returns object of contest dashboard details
 */
export const getContestDashboardDetails = async (contestId) => {
  const response = await axios.get(
    `contests/dashboard-stages?contestId=${contestId}`
  )
  return response
}

/**
 *
 * @param {string} contestId
 * @returns data for previous stage's leaderboard to enable current stage
 *
 */
export const getDashboardLeaderboardData = async (stageId) => {
  const response = await axios.get(
    `attempt-results/leaderboard-evaluations?contestStageId=${stageId}`
  )
  return response
}

/**
 * Checks if the first stage of a contest is enabled.
 *
 * @param {string} contestId - The ID of the contest.
 * @returns {Promise<boolean>} - A promise that resolves to `true` if the first stage is enabled, otherwise `false`.
 */
export const getFirstStageEnableStatus = async (contestId) => {
  const response = await axios.get(`contests/${contestId}/can-edit`)
  return response
}

/**
 *
 * @param {object} payload {startTime,contestStageId}
 * @returns
 */
export const enableOrScheduleStage = async (payload) => {
  const response = await axios.post(`candidate-attempts/enable-stage`, payload)
  return response
}

/**
 *
 * @param {object} payload {rejectIds:[],stageId:string}
 * @returns
 */
export const rejectCandidateAndFinishAttempt = async (payload) => {
  const response = await axios.post(
    `candidate-attempts/evaluate-stage`,
    payload
  )
  return response
}

/**
 *
 * @param {object} payload {scheduleIds:array of ids}
 * @returns
 */
export const retryEnableForFailedCandidates = async (payload) => {
  const response = await axios.post(`candidate-attempts/failed-retry`, payload)
  return response
}

/*
 * @param {Number} assessmentId
 * @returns
 */
export const getAssessmentStagesDetails = async (assessmentId) => {
  const response = await axios.get(
    `assessments/dashboard/stages?assessmentId=${assessmentId}`
  )
  return response
}

export const getAssessmentDashboardActiveStageCandidate = async (
  payload,
  assessmentId,
  stageId
) => {
  const response = await axios.post(`assessments/dashboard/stages`, payload, {
    params: {
      assessmentId,
      stageId
    }
  })
  return response
}

export const getAssessmentResumeStageCandidate = async (payload) => {
  const response = await axios.post(`resume/stage`, payload)
  return response
}

/**
 *
 * @param {Number} candidateId
 * @param {Number} assessmentId
 * @returns
 */
export const getActiveCandidateAssessmentDetails = async (
  candidateId,
  assessmentId
) => {
  const response = await axios.get(
    `candidates/candidate-assessment-details?candidateId=${candidateId}&assessmentId=${assessmentId}
`
  )
  return response
}

/**
 *
 * @param {object} payload  {contestStageId,candidateId:number,startTime}
 * @returns
 */
export const enableOrScheduleStageForAssessment = async (payload) => {
  const response = await axios.post(
    `candidate-attempts/enable-schedule-candidate`,
    payload
  )
  return response
}

export const getUserProfileImages = async (payload) => {
  const response = await axios.post('users/profile-photos', payload)
  return response
}

/**
 *
 * @param {object} payload {assessmentId,candidateId,score,feedback}
 * @returns
 */
export const concludeAssessment = async (payload) => {
  const response = await axios.post(`contests/conclude`, payload)
  return response
}

/**
 *
 * @param {string} assessmentId
 * @param {string} candidateId
 * @returns
 */
export const getCandidateSummary = async (assessmentId, candidateId) => {
  const response = await axios.get(
    `candidates/download-summary?candidateId=${candidateId}&assessmentId=${assessmentId}`
  )
  return response
}

/**
 *
 * @param {string} workspaceId
 * @returns array of object {id:number,}
 */
export const getFormOptions = async (workspaceId = '') => {
  const response = await axios.get(`contest-forms`, {
    params: { workspaceId }
  })
  return response
}

/**
 *
 * @param {string} contestId
 * @returns
 */
export const closeFormRegistration = async (contestId) => {
  const response = await axios.put(
    `contest-forms/${contestId}/registration-close`
  )
  return response
}

/**
 *
 * @param {string} contestUri
 * @returns
 */
export const shouldShowDetailsForm = async (contestUri = null) => {
  const response = await axios.get(
    `/contest-forms/${contestUri}/show-registration-form`
  )
  return response
}

export const exportAssessmentCandidateResume = async (
  assessmentId,
  candidateId
) => {
  const response = await axios.get(
    `candidates/${candidateId}/resume/export?assessmentId=${assessmentId}`,
    { responseType: 'blob' }
  )
  return response
}

export const uploadCandidateResume = async (
  assessmentId,
  candidateId,
  payload
) => {
  const response = await axios.put(
    `candidates/${candidateId}/resume?assessmentId=${assessmentId}
`,
    payload
  )
  return response
}

export const inviteAssessmentCandidate = async (formData) => {
  const response = await axios.post('/candidates/assessment-invite', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return response
}
/**
 *
 * @param {string} contestId
 */
export const registrationFormFields = async (contestId) => {
  const response = await axios.get(`contests/${contestId}/formFields`)
  return response
}

/**
 *
 * @param {object} payload {attemptIds:[],action}
 * @returns
 */
export const markCandidateStatus = async (payload) => {
  const response = await axios.put(`/candidate-attempts/status`, payload)
  return response
}

/**
 *
 * @param {string} attemptId
 * @returns
 */
export const getContestAttemptStatus = async (attemptId) => {
  const response = await axios.get(`candidate-attempts/candidate-evaluation`, {
    params: { attemptId }
  })
  return response
}

/**
 *
 * @param {object} payload  add contest stage before contest start
 * @param {string} contestId
 * @returns
 */
export const addPreStartContestStage = async (payload, contestId) => {
  const response = await axios.post('contest-stages', payload, {
    params: {
      contestId
    }
  })
  return response
}

/**
 *
 *
 * @param {string} stageId delete contest stage before contest start
 * @param {string} contestId
 * @returns
 */
export const deletePreStartContestStage = async (stageId, contestId) => {
  const response = await axios.delete(`/contest-stages/${stageId}`, {
    params: {
      contestId
    }
  })
  return response
}

/**
 *
 * @param {object} payload  update contest stage sequence before contest start
 * @param {string} contestId
 * @returns
 */
export const updatePreStartContestStageSequenceChange = async (
  payload,
  contestId
) => {
  const response = await axios.put('contest-stages/change-sequence', payload, {
    params: {
      contestId
    }
  })
  return response
}

/**
 *
 * @param {string} scheduleId
 * @returns
 */
export const getInterviewersOfStage = async (scheduleId) => {
  const response = await axios.get('/interviewers', { params: { scheduleId } })
  return response
}

/**
 *
 * @param {string} contestId
 * @param {boolean} isArchive
 * @returns
 */
export const updateArchiveStatus = async (contestId, isArchive) => {
  const response = await axios.put(`/contests/${contestId}/archive`, null, {
    params: { isArchive }
  })
  return response
}

export const uploadVideoResponseRecordedVideo = async (formData) => {
  const response = await axios.post(`video-questions/upload-video`, formData)
  return response
}

export const deleteVideoResponseRecordedVideo = async (filePath, contestId) => {
  const response = await axios.post(
    `video-questions/delete-bulk-video${
      contestId ? `?contestId=${contestId}` : ''
    }`,
    filePath
  )
  return response
}

export const updateVideoResponseQuestionRetakeCount = async (
  attemptId,
  questionId
) => {
  const response = await axios.post(
    `video-stage-logs/retake?attemptId=${attemptId}&questionId=${questionId}`
  )
  return response
}

export const uploadVideoResponseCandidateRecordedStream = async (payload) => {
  const response = await axios.post(`video-stage-logs/upload-video`, payload)
  return response
}

export const skipVideoResponseQuestion = async (attemptId, questionId) => {
  const response = await axios.post(
    `video-stage-logs/skip?attemptId=${attemptId}&questionId=${questionId}`
  )
  return response
}

export const submitVideoResponseCandidateRound = async (attemptId) => {
  const response = await axios.post(
    `candidate-attempts/submit-video-stage?attemptId=${attemptId}`
  )
  return response
}

export const getVideoResponseEvaluateDetails = async (attemptId) => {
  const response = await axios.get(`video-stage-logs?attemptId=${attemptId}`)
  return response
}

export const addUpdateVideoResponseEvaluateScore = async (payload) => {
  const { isUpdated = false, ...rest } = payload
  const response = isUpdated
    ? await axios.put(`video-stage-logs/update-marks`, rest)
    : await axios.post(`video-stage-logs/add-marks`, rest)
  return response
}

/**
 *
 * @param {string} attemptId
 * @returns
 */
export const getAIScoreMetrics = async (attemptId, challengeId) => {
  const response = await axios.get(`attempt-results/metrics`, {
    params: { attemptId, challengeId }
  })
  return response
}

/**
 *
 * @param {object} payload // {candidateId,contestId,stageId,worksapceId,attemptId,startWindowDuration,startWindowDurationUnit}
 * @returns
 */
export const updateDeadlineWindow = async (payload) => {
  const response = await axios.put(`assessments/start-window`, payload)
  return response
}

export const bulkCandidateActions = async (payload) => {
  const response = await axios.post('/contests/bulk-candidates', payload)
  return response
}

export const registrationFormInfo = async (contestId) => {
  const response = await axios.get(
    `contest-forms/registration-info?contestId=${contestId}`
  )
  return response
}

export const invalidatedCandidateInvite = async (contestId, candidateId) => {
  const response = await axios.put(`candidates/invalidate`, null, {
    params: { contestId, candidateId }
  })
  return response
}

export const getAuxiliaryEvidence = async (attemptId) => {
  const response = await axios.get(
    `candidate-attempts/aux-images?attemptId=${attemptId}`
  )
  return response
}

export const getGazeInfo = async (attemptId) => {
  const response = await axios.get(
    `candidate-attempts/gaze-cluster?attemptId=${attemptId}`
  )
  return response
}

export const getContestListForCredits = async () => {
  const response = await axios.get(`contests/fetch-all`)
  return response
}

export const getStageScoreBreakdown = async (attemptId) => {
  const response = await axios.get(
    `attempt-results/score-breakdown?attemptId=${attemptId}`
  )
  return response
}
